import { getStreamIQConstants } from '@/shared/getContainer/getStreamIQConstants'

const constant = await getStreamIQConstants()
const { SHOW_TYPE, MOVIE_TYPE, MOVIE_EVENT_TYPE } = constant || {}

export const vodPagePath = '/vod'
export const vodRowsRequestKeyword = 'vod/rows'
export const vodItemDetailsAdverts = 'adverts'
export const vodItemsRequestKeyword = 'vod/items'
export const vodPlaybacksRequestKeyword = 'playbackUrl'
export const vodPlaybacksPositionRequestKeyword = 'playbackPosition'
export const vodDetailsRequestKeyword = 'vod/details'
export const vodSeriesDetailsRequestKeyword = 'vod/seriesdetails'
export const vodPurchaseUrl = 'https://beta-api-atv.toya.net.pl/vod/purchase'

export const vodSliderButtonHeight = 96
export const vodSliderButtonWidth = 96
export const vodItemImageHeight = 380
export const vodZeroRowItemImageHeight = 580
export const maxRecommendationItemHeight = 347
export const vodItemMinHeight = 200
export const episodeItemHeight = 150
export const _defaultVodRowsCount = 3
export const distanceThreshold = 100

export const cutvType = 'cutv'
export const channelType = 'channel'
export const externalType = 'external'
export const vodType = 'vod'
export const vodTypeSeries = 'series'
export const vodTypeEpisodes = 'episode'
export const vodContentType = [
    vodType,
    vodTypeSeries,
    vodTypeEpisodes,
    MOVIE_TYPE,
    SHOW_TYPE,
    MOVIE_EVENT_TYPE,
]
export const catType = 'cat'
export const webType = 'web'

export const VodPageType = 'VodPage'
export const VodPageId = 'VOD'
export const VodPageDetailsType = 'VodDetailsPage'
export const continueWatchingKeyword = 'system_continue_watching'
export const VodPageDetailsRecommendationPrefix = 'RCMD:'
export const isPurchasedBuy = 1
export const isPurchasedPlay = 2

export const vodAutoRefreshMinutes = 30 * 60 * 1000

export const vodExternalLinkTypeLiveTV = 'livetv'
export const vodExternalLinkTypeProgram = 'program'

export const fetchItemsAmount = 50
